import * as React from "react";
import { useBloomreachPageName, useBloomreachPageHasComponent } from "@grandvisionhq/bloomreach";
import { useTealiumEventProperties, useTrackPageView } from "@grandvisionhq/svc-tealium/events";
const TealiumContentPageView = ({
  children
}) => {
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const pageName = useBloomreachPageName();
  const isHomePage = pageName === "homepage";
  const isContactPage = useBloomreachPageHasComponent({ componentName: "GlobalContactForm" });
  const contentPageView = React.useCallback(
    async () => {
      const commonUserProperties = await getCommonUserProperties();
      if (!commonUserProperties) return;
      const sharedProperties = {
        ...commonEventProperties,
        ...commonUserProperties,
        id: "VirtualPage-View"
      };
      if (isHomePage) {
        return {
          ...sharedProperties,
          Page_Type: "Home",
          Page_Section1: "Home"
        };
      }
      if (isContactPage) {
        return {
          ...sharedProperties,
          Page_Type: "Static",
          Page_Section1: "GetSupport"
        };
      }
      return {
        ...sharedProperties,
        Page_Type: "Static",
        Page_Section1: "Other",
        Page_Section2: ""
      };
    },
    // Only need to trigger this page view on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getCommonUserProperties]
  );
  useTrackPageView(contentPageView);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export {
  TealiumContentPageView as T
};
//# sourceMappingURL=TealiumContentPageView.js.map
